import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Calendar page — date-specific glyph for scheduling and event forms.
 *  Kept static so it reads as a stable date container; active state is
 *  handled by the field chrome that owns focus / filled transitions. */
export function IcnCalendar(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="calendar">
      <rect x="2.5" y="3.5" width="11" height="10" rx="2" />
      <path d="M5.5 2v3" />
      <path d="M10.5 2v3" />
      <path d="M2.5 6.5h11" />
      <path d="M5 9h1.2" />
      <path d="M7.4 9h1.2" />
      <path d="M9.8 9h1.2" />
      <path d="M5 11.2h1.2" />
      <path d="M7.4 11.2h1.2" />
    </Svg>
  );
}
